import { WDSSortFieldWay } from '@wizeoo/akm-core-lib';
import {
  WizBasePopUp,
  WizLabel,
  WizDatasource,
  WizAgGrid
} from '@wizeoo/akm-component-lib';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { FeiVO } from '../../../../../vo/workingdata/fei.vo';
import { IWidget, PivotCellEditPopData } from '../../../../../manager/widgets/i-widget';
import { EM_ACTION, FeiKeyDef, FIELD_KIND, WidgetLine, WizConstants } from '@wizeoo/akm-compute-lib';
import { CellClickedEvent, ColDef } from 'ag-grid-community';
import { Measure, WidgetConfigurationObj } from '@wizeoo/akm-message-lib';
import { UpdateRequest } from '../../../../../command/core/sync/sync.service';
import { ListFieldGridDatas } from '../../../../../manager/workingdata/listfield.engine';
import { GridOptions } from '@ag-grid-community/core';
import { PivotCellEditor } from './pivot-cell.editor';
import { ToolPivot } from '../../../../tools/tool-pivot.component';
import { Model } from '../../../../../model/model';
import { FreedataValueVO } from '../../../../../vo/core/freedatavalue.vo';
import { FreedataArgsVO } from '../../../../../vo/core/freedataargs.vo';
import { OtherCellEditor } from './other-cell.editor';


/**
 * un champ du seuil
 */
export interface ThresholdField {
  label: string,
  code: string,
  kind: string,
  sort: string,
  order?: number,
  format?: string,
}


/**
 * une demande de navigation par page en mode compute
 */
export interface ThresholdLine {
  values: Map<string, any>,
  uk: any
}


@Component({
  // popUp d'édition des cellules de type filterKey
  selector: 'pivot-cell-threshold-edit-pop',
  templateUrl: './pivot-cell-threshold-edit.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PivotCellThresholdEditPop extends WizBasePopUp {
  
  @ViewChild('agGrid') agGrid: WizAgGrid<ThresholdLine>; // grid
  @ViewChild('lbTitle', { read: WizLabel, static: false }) lbTitle: WizLabel; // titre de la popUp (fullcode)

  /** accesseur avec cast */
  private get popupData(): PivotCellEditPopData {
    return this.datas as PivotCellEditPopData;
  }

  public columns: ColDef[]; // Colonnes du grid
  
  /** composant utilisés par le grid */
  public gridFrameworkComponents = { pivotCellEditor: OtherCellEditor };

  /** la DS de la liste. On recycle le mécanisme d'alimentation des filtres, il marche bien avec freedata et chrono */
  public mainDS: WizDatasource<ThresholdLine> = new WizDatasource<ThresholdLine>([])
    .setSelectionMode('single')
    .build();


  public static baseWidth: number = 500;
  public static baseHeight: number = 400;

  public value: any = null;
  public settings: any = null;
  public fields: ThresholdField[];
  public fieldsMap: Map<string, ThresholdField>;
  public keyField: string = null;
  public keyFieldObj: ThresholdField = null;

  public get model(): Model{
    return this.popupData?.widget?.model;
  }

  // configuration, construite par le ListFieldEngine
  public listFieldGridDatas: ListFieldGridDatas = null;

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  // indice de void
  public idx: number = 0;

  /**
   * objet source FDV / BL
   */
  public mode: string = 'BL'; // BL ou FDV

  show(): void {
    this.settings = this.popupData.settings;
    this.value = this.popupData.value;
    
    // console.log('thres', this.settings, this.value);
    // prise du label du champ d'origine
    this.lbTitle.wizLabel = this.datas.title;

    this.builFields();
    this.buildLines();
    this.addListeners();
  }

  /** configuration de l'agGrid */
  gridOptions: GridOptions = {
    stopEditingWhenCellsLoseFocus: true, // 
    suppressRowClickSelection: true, // pas de sélection directe, on gère nous même
    getRowNodeId: (params) => params?.uk, // ce qui définit la clé : la clé unique de widgetLine
  };

  /**
   * construction des champs
   */
  public builFields(): void {
    let fields: ThresholdField[] = [];
    let fieldsMap: Map<string, ThresholdField> = new Map();
    let columns: any[] = []; // colDef + tsf = ThresholdField

    this.settings.keys.forEach( k => {

      let f: ThresholdField = {"code": k.code, "kind": k.kind, "sort": k.sort, "label": k.label, order: 0, format:k.format || null};
      
      let col: any = {
            field: f.code, // FD ou CHRONO et #lvl ou MEASURE#Mode
            headerName: f.label || f.code, // label défini dans le contexte, ou par défaut
            tsf: f,
            dataformat: f.format,
            editable: true, // pas d'édition par défaut
            sortable: false, // gestion du tri
            valueSetter : this.updateCell.bind(this), // méthode de persistence des modifs
            valueGetter: this.valueAccessor.bind(this),
            valueFormatter: this.valueFormatterAccessor,
            cellEditor: 'pivotCellEditor' // ajouté au framework du grid dans pivotComponent.drawContent; Editeur unique
          };
      columns.push(col);

      fieldsMap.set(f.code, f);
      fields.push(f);
      if(!this.keyField) {
        this.keyField = f.code;
        this.keyFieldObj = f;
        let isnum = this.model.dataEngine.datakindIsNumeric(f.kind); 
        let way: WDSSortFieldWay = f.sort? f.sort.toLocaleLowerCase() as WDSSortFieldWay : 'asc';

        // gestion du sort forcé
        col.comparator = (valueA, valueB) => {

          if (valueA == null && valueB == null) return 0;
          if (valueA == null) return 1;   // A après B
          if (valueB == null) return -1;  // B après A
          return valueA - valueB;
        }
        // tri initial
        col.sort = way;

        // this.mainDS.setSortFields([{ property: this.keyField, way: way, numeric: isnum }]);
      }
    });
    this.fieldsMap = fieldsMap;
    this.fields = fields;
    this.columns = columns;
 

  }

  public buildLines(): void {

    let protoArr: any[] = null;
    if(this.value) {
      protoArr = JSON.parse(this.value);
    }

    // console.log('protoArr', protoArr);
    let lines: ThresholdLine[] = [];
    
    protoArr?.forEach(protoItem => {
      let values: Map<string, any> = new Map();
      let uk: any;
      this.fields.forEach(tf =>{
        if(protoItem[tf.code] !== undefined) {
          let isnum = this.model.dataEngine.datakindIsNumeric(tf.kind); 
          if(isnum) {
            values.set(tf.code, Number(protoItem[tf.code]));
          } else {
            values.set(tf.code, protoItem[tf.code]);
          }
          if(tf.code === this.keyField) {
            uk = protoItem[tf.code];
          }
        }
      });
      let line: ThresholdLine = {uk, values};
      lines.push(line);
    });

    // console.log('protoArr', protoArr);

    while(lines.length < 20) {
      let values: Map<string, any> = new Map();
      let uk: any;
      this.fields.forEach(tf =>{
        if(tf.code === this.keyField) {
          uk = ['VOID', this.idx].join(WizConstants.KEY_SEPARATOR);
        }
        values.set(tf.code, null);
      });

      let line: ThresholdLine = {uk, values};
      lines.push(line);
      this.idx++;
    }


    // TODO SORT

    this.mainDS.setSource(lines);
    this.playSort();
  }


  /** mise en place des écouteurs */
  public addListeners(): void {
  }

  /** Sauvegarde */
  public save(): void {
    
    let result: string = null;
    let values: string[] = [];

    this.mainDS.getSource().forEach(tl => {
      if(tl.values.get(this.keyField) !== null && tl.values.get(this.keyField) !== undefined) {
        const str = JSON.stringify(Object.fromEntries(tl.values));
        values.push(str);
      }
      // console.log('tl', tl.values);
    });

    if(values.length > 0) {
      result = ['[', values.join(','), ']'].join('');
    }

    const updates: UpdateRequest = {
      fei: this.popupData.widget?.fei, 
      line: this.popupData.line,
      lines: this.popupData.pack, 
      operation: EM_ACTION.UPDATE,
      fkd: this.popupData.fkd,
      value: result,
      doSplit: false
    };

    this.popupData.updates = updates;
    this.popupData.callback(this.popupData); // on appelle la callback avec le pack d'updates

    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    // this.doSaveFlag = false;
    this.hide();
  }

  public hide() {
    super.hide();
  }

  public valueAccessor(params: any): any {
    const line: ThresholdLine = params.data; // ligne source
    const colDef: ColDef = params.colDef; // définition de la colonne
    return line.values.get(colDef.field);
  }

  public valueFormatterAccessor(params: any): string {  

    const line: ThresholdLine = params.data; // ligne source
    const colDef: any = params.colDef; // définition de la colonne
    let tsf: ThresholdField = colDef.tsf;
    let result: string = null;

    let format: string = colDef.dataformat || null;

    // prise du format sur le FKD, le colDef.datakind est possiblement un aggrégat d'un autre type
    let datakind: string = tsf.kind;

    result = Model.getInstance().formatEngine.applyFormat(params.value?.toString(), datakind, format, null);   
    // console.log('valueFormatter', line.key, line.isTotalLine, line.isSubTotalLine,params.colDef, params.value,  result);
    return result;
    
  }



 /**
   * mise à jour de la valeur d'une cellule en édition directe
   * possible saisie en masse. Le mode sera dans ce cas déterminé par mem (massEditMode)
   *
   * @param cell contient le node (la ligne), la WidgetLine porteuse, la colDef, la oldValue et la newValue
   */
  public updateCell(cell: any): boolean {
      
    if (cell.newValue !== cell.oldValue) {
      
      // TODO contrôle d'unicité

      const line: ThresholdLine = cell.data;
      const colDef: ColDef = cell.colDef; // définition de la colonne
      line.values.set(colDef.field, cell.newValue);
      if(colDef.field === this.keyField) {
        line.uk = cell.newValue;
      }
    }
    this.playSort();
    return true;
  }

  public playSort(): void {
    this.mainDS.refresh();
  }

  /** 
   * demande de suppression d'une ligne
   * @param params tout le bazard { colDef, data, column, event, value }
   * @returns 
   */
  public onItemDeleted(params: CellClickedEvent): void {
    let tl: ThresholdLine = params.data;
    if(tl.uk.toString().indexOf('VOID') > -1) {
      // un fake, on ne fait rien
    } else {
      tl.uk = ['VOID', this.idx].join(WizConstants.KEY_SEPARATOR);
      this.idx++;
      [...tl.values.keys()].forEach(k => {
        tl.values.set(k, null);
      });
    }
    this.agGrid?.api.refreshCells();
    this.playSort();
    // console.log('onItemDeleted', params);
  }

}
